<div
  class="sub-nav"
  *ngIf="navigationInfo && navigationInfo.navigationItems?.length"
>
  <a
    *ngFor="let item of navigationInfo.navigationItems"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: item.isExact }"
    [queryParams]="item.queryParams"
    [queryParamsHandling]="item.queryParamsHandling || null"
    [routerLink]="
      item.routerLinkParams
        ? [item.routerLink, item.routerLinkParams]
        : item.routerLink
    "
    [attr.data-dgat]="item.dgat"
    [attr.aria-current]="isRouteActive(item.routerLink) ? 'page' : null"
  >
    {{ item.label }}
  </a>
</div>
